<template>
  <div v-loading="pageloading">
    <el-form label-width="80px" style="width:350px;">
      <el-form-item label="OA用户">
        <el-select
          v-model="oaUser"
          filterable
          remote
          reserve-keyword
          placeholder="用户名进行模糊查询"
          value-key="userId"
          :remote-method="getOaUserByKey"
        >
          <el-option
            v-for="item in oaUserList"
            :key="item.userId"
            :label="`${item.userName}  ${item.deptName}`"
            :value="item"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addAuthOa">授权</el-button>
      </el-form-item>
    </el-form>
    <span style="float: left;font-size: 30px;font-weight: bolder;color: deepskyblue;margin-bottom: 10px">授权用户：</span>
    <template>
      <el-table
        :data="tableDataVO"
        style="width: 100%"
      >
        <el-table-column
          width="180"
          label="用户ID"
          prop="userId"
        />
        <el-table-column
          width="180"
          label="用户姓名"
          prop="userName"
        />
        <el-table-column
          width="180"
          align="right"
        >
          <template slot="header">
            <el-input
              v-model="search"
              size="mini"
              @change="selectAuthUser(search)"
              placeholder="输入用户名搜索"
            />
          </template>
          <template>
            <el-button
              size="mini"
              type="primary"
              @click="deleteAuthUser(scope.row.userId)"
            >
              删除权限
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="block" style="width: 180px !important;">
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalNum"
        />
      </div>
    </template>
  </div>
</template>

<script>
import api from '../../api';

export default {
  name: 'UserAuth',
  data () {
    return {
      oaUser: {},
      partnerUser: {},
      oaUserList: [],
      partnerUserList: [],
      pageloading: false,
      tableData: [],
      tableDataVO: [],
      search: '',
      pageSize: 15,
      totalNum: 0,
      pageNum: 1
    };
  },
  mounted () {
    this.swtichUserAuthority();
    this.selectAuthUser();
  },
  methods: {
    handleCurrentChange (val) {
      this.pageNum = val;
      let that = this;
      let start = that.pageSize * (val - 1);
      let end = that.pageSize * val;
      if (that.tableData.length <= that.pageSize) {
        that.tableDataVO = that.tableData;
      } else {
        if (that.pageSize * val >= that.tableData.length) {
          that.tableDataVO = that.tableData.slice(start);
        } else { // 用户点击的那一页不是最后一页的数据，比如有49条数据，用户点击第二页，第二页就应该显示20至40条的数据
          that.tableDataVO = that.tableData.slice(start, end);
        }
      }
      // this.selectAuthUser();
    },

    getOaUserByKey (key) {
      this.pageloading = true;
      api.getOaUserByKey(key).then(resp => {
        if (resp.data.status === '200') {
          this.oaUserList = resp.data.data;
          // this.totalNum = this.oaUserList.length;
          // console.log("this.oaUserList=",this.oaUserList);
          // console.log("this.totalNum=",this.totalNum);
          this.pageNum = 1;
          this.pageloading = false;
        }
      })
        .catch(e => {
          console.log('e', e);
          this.pageloading = false;
        });
    },
    getPartnerUserByKey (key) {
      this.pageloading = true;
      api.getPartnerUserByKey(key).then(resp => {
        if (resp.data.status === '200') {
          this.partnerUserList = resp.data.data;
          this.pageloading = false;
        }
      })
        .catch(e => {
          console.log('e', e);
          this.pageloading = false;
        });
    },
    addAuthOa () {
      let body = {
        authUser: this.oaUser,
        userType: 1
      };
      this.pageloading = true;
      api.addAuthUser(body).then(resp => {
        if (resp.data.status === '200') {
          this.pageloading = false;
          this.$message({
            type: 'success',
            message: '授权成功'
          });
          this.tableData = null;
          this.selectAuthUser();
        }
      })
        .catch(e => {
          console.log('e', e);
          this.pageloading = false;
        });
    },
    deleteAuthUser (userId) {
      api.deleteByuserId({ params: { userId: userId } }).then(resp => {
        if (resp.data.status === '200') {
          this.$message({
            type: 'success',
            message: '删除成功'
          });
          this.tableData = null;
          this.selectAuthUser();
        }
      });
    },
    swtichUserAuthority () {
      api.swtichUserAuthority().then(resp => {
        if (resp.data.status === '200') {
          console.log(resp.data);
        }
      })
        .catch(e => {
          console.log('e', e);
        });
    },
    selectAuthUser (userKey) {
      api.selectAuthUser({ params: { userKey: userKey } }).then(resp => {
        if (resp.data.status === '200') {
          this.pageNum = 1;
          this.tableData = resp.data.data;
          this.totalNum = this.tableData.length;
          this.tableDataVO = this.tableData.slice(this.pageNum - 1, this.pageSize);
        }
      }).catch(e => {
        console.log('e', e);
      });
    }
  }
};
</script>

<style scoped>

</style>
